import { defineComponent as _defineComponent } from 'vue'
import Icon from 'JS/components/Icon.vue';
import { IWarranty } from 'JS/types/Product';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppliedWarranty',
  props: {
    appliedWarranty: null
  },
  setup(__props: any) {

const props = __props as {
	appliedWarranty: IWarranty | null,
}



return { __sfc: true,props, Icon }
}

})